import type { PurchaseOrderReportBySupplierRow } from "@/modules/reports/domain/repo/purchase-order/get-purchase-order-report-by-supplier";
import type { PurchaseOrderLeadTimeReport } from "@/modules/reports/domain/repo/purchase-order/get-purchase-order-lead-time-report";
import type { PurchaseOrderReportSummary } from "@/modules/reports/domain/repo/purchase-order/get-purchase-order-report-summary";

function csvCell(value: unknown) {
  return `"${String(value ?? "").replace(/"/g, '""')}"`;
}

function csvRow(cells: unknown[]) {
  return cells.map(csvCell).join(",");
}

export function downloadPurchaseOrderReportCsv(payload: {
  summary: PurchaseOrderReportSummary;
  bySupplier: PurchaseOrderReportBySupplierRow[];
  leadTime?: PurchaseOrderLeadTimeReport;
  filename?: string;
}) {
  const { summary, bySupplier, leadTime } = payload;

  const summarySection = [
    csvRow(["ສະຫຼຸບ PO ຄ້າງຮັບ"]),
    csvRow(["PO ຄ້າງຮັບ", summary.openReceivablePoCount]),
    csvRow(["PO ລໍຖ້າອະນຸມັດ", summary.submittedPendingCount]),
    csvRow(["ບັນທັດຄ້າງ", summary.openLineCount]),
    csvRow(["ປະລິມານຄ້າງ", summary.qtyOpen]),
    csvRow(["ມູນຄ່າຄ້າງ (₭)", summary.valuePendingLak]),
    "",
  ];

  const supplierHeaders = [
    "ລະຫັດຜູ້ສະໜອງ",
    "ຊື່ຜູ້ສະໜອງ",
    "PO ຄ້າງ",
    "ບັນທັດ",
    "ປະລິມານຄ້າງ",
    "ມູນຄ່າຄ້າງ (₭)",
  ];
  const supplierRows = bySupplier.map((row) =>
    csvRow([
      row.supplierCode ?? "",
      row.supplierName,
      row.openPoCount,
      row.openLineCount,
      row.qtyOpen,
      row.valuePendingLak,
    ]),
  );

  const leadTimeSection =
    leadTime && leadTime.items.length > 0
      ? [
          "",
          csvRow(["Lead time (order → first receive)"]),
          csvRow([
            "PO ມີການຮັບ",
            leadTime.poCountWithReceive,
            "ຄ່າສະເລ່ຍ (ວັນ)",
            leadTime.avgLeadDays ?? "",
          ]),
          csvRow([
            "PO No",
            "ຜູ້ສະໜອງ",
            "ວັນທີສັ່ງ",
            "ຮັບຄັ້ງທຳອິດ",
            "Lead (ວັນ)",
            "ສະຖານະ",
          ]),
          ...leadTime.items.map((row) =>
            csvRow([
              row.poNo,
              row.supplierName,
              row.orderDate,
              row.firstReceivedAt ?? "",
              row.leadDays ?? "",
              row.status,
            ]),
          ),
        ]
      : [];

  const csv = [
    ...summarySection,
    csvRow(supplierHeaders),
    ...supplierRows,
    ...leadTimeSection,
  ].join("\n");

  const blob = new Blob(["\uFEFF" + csv], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download =
    payload.filename ??
    `po-report-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
